import React from 'react'
import type { RichTextBlockEntryFragment } from '../../../.graphql/generated-types'
import { useContentful } from '../../utils/contentful-context'

export interface RichTextBlockEntryProps {
  data: RichTextBlockEntryFragment
}

export function RichTextBlockEntry({ data }: RichTextBlockEntryProps) {
  const { blockComponents } = useContentful()

  const {
    BlockQuote,
    ContentfulImage,
    DownloadableAsset,
    HorizontalImageCTA,
    ImageAndAdjacentTextList,
    ComposeComponentRichTextCTA,
    YoutubeVideo,
    RichTextColouredBackground,
  } = blockComponents

  switch (data.__typename) {
    case 'ComposeComponentBlockQuote':
      return <BlockQuote data={data} />
    case 'ComposeComponentImage':
      return <ContentfulImage data={data} />
    case 'ComposeComponentDownloadableAsset':
      return <DownloadableAsset data={data} />
    case 'ComposeComponentHorizontalImageCta':
      return <HorizontalImageCTA data={data} />
    case 'ComposeComponentRichTextCta':
      return <ComposeComponentRichTextCTA data={data} />
    case 'ComposeComponentRichTextColouredBackground':
      return <RichTextColouredBackground data={data} />
    case 'ComposeComponentYoutubeVideo':
      return <YoutubeVideo data={data} />
    case 'ComposeComponentImageAndAdjacentTextList':
      return <ImageAndAdjacentTextList data={data} />
    default:
      return null
  }
}
